import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../../../../../actions/modal.actions';
import { getAccountDetails, getModalData } from '../../../../../../selectors';
import { updateServiceLineNumber } from '../../../../../../actions/serviceLine.actions';
import { getServicesAndEquipment } from '../../../../../../actions/accountDetailsActions/servicesAndEquipment.actions';
import isEmpty from '../../../../../../utils/helpers';
import { toastr } from 'react-redux-toastr';

class EditServiceLineNumberModal extends Component {

    state = {
        newNumber: this.props.modalProps.currentNumber || '',
        alertMessage: '',
        isSaving: false,
        numberInUse: false,
    };

    closeModal = () => {
        this.props.hideModal();
    };

    handleChange = (e) => {
        const value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
        this.setState({ newNumber: value, alertMessage: '', numberInUse: false });
    };

    handleSave = () => {
        const { newNumber } = this.state;
        const { serviceLineId, serviceLineNumId, currentNumber, showHistoricalData } = this.props.modalProps;
        const { accountId } = this.props;

        if (!newNumber || newNumber.trim() === '') {
            this.setState({ alertMessage: 'Please enter a phone number.', numberInUse: true });
            return;
        }

        if (newNumber.trim() === currentNumber) {
            this.setState({ alertMessage: 'The new number must be different from the current number.', numberInUse: true });
            return;
        }

        this.setState({ isSaving: true });

        this.props.updateServiceLineNumber(accountId, serviceLineId, serviceLineNumId, newNumber.trim())
            .then(response => {
                const data = response.data || (response.response && response.response.data);

                if (data && data.success) {
                    toastr.success('Service line number updated successfully.', { timeOut: 2000, position: 'top-center' });
                    this.props.getServicesAndEquipment(accountId, showHistoricalData);
                    this.props.hideModal();
                } else {
                    const message = (data && data.error && data.error.message) || 'Save failed. Please try again.';
                    this.setState({ isSaving: false, alertMessage: message, numberInUse: true });
                }
            })
            .catch(error => {
                const data = error.response && error.response.data;
                const message = (data && data.error && data.error.message) || 'Save failed. Please try again.';
                this.setState({ isSaving: false, alertMessage: message, numberInUse: true });
            });
    };

    render() {
        const { newNumber, alertMessage, isSaving, numberInUse } = this.state;
        const { currentNumber } = this.props.modalProps;

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit ServiceLine Number</h5>
                                <button onClick={this.closeModal} type="button" className="close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {!isEmpty(alertMessage) && (
                                    <div className="alert alert-inline alert-danger alert-dismissible">
                                        <p className="mb-0">{alertMessage}</p>
                                    </div>
                                )}
                                <div className="form-horizontal">
                                    <div className="form-group">
                                        <label>Current Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={currentNumber}
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>New Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={numberInUse ? { borderColor: '#dc3545', boxShadow: '0 0 0 0.2rem rgba(220,53,69,.25)' } : {}}
                                            value={newNumber}
                                            onChange={this.handleChange}
                                            disabled={isSaving}
                                            placeholder="Enter new number"
                                            maxLength={20}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    onClick={this.closeModal}
                                    className="btn"
                                    type="button"
                                    disabled={isSaving}
                                >
                                    Exit
                                </button>
                                <button
                                    onClick={this.handleSave}
                                    className="btn btn-primary"
                                    type="button"
                                    disabled={isSaving}
                                >
                                    {isSaving ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps;
    const accountId = getAccountDetails(state).accountDetails.accountInfo.id;
    return {
        accountId,
        modalProps,
    };
};

const mapDispatchToProps = {
    hideModal,
    updateServiceLineNumber,
    getServicesAndEquipment,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditServiceLineNumberModal);
